import $ from 'static/script/libs/jquery';
import defineComponent from 'flight';
import isHybridApp from 'static/script/utils/is-hybrid-app';

function SearchResultFilterBoxUI() {
    this.BUTTON_ACTION = {
        collapse: 'collapse',
        expand: 'expand'
    };

    this.HIDDEN_CLASS = 'hidden';

    this.defaultAttrs({
        itemLinks: '[data-nav]',
        boxHeader: '[data-search-filter-header]'
    });

    this._toggleFilterBox = function () {
        let action;
        this.$node.toggleClass('search-filters-section-open');

        // Event for A/B test
        if (this.$node.parent().hasClass('search-filters-section-categories')) {
            action = this.$node.hasClass('search-filters-section-open') ? 'Open' : 'Close';
            action = action + ' categories inside filter';
            this._trackCategories(action);
        }
    };

    this._trackCategories = function (label) {
        this.trigger(document, 'analytics:track-event', {
            category: 'Search',
            action: 'Toggle',
            label: label
        });
    };

    this._setLoadingStateOnSelected = function (evt) {
        if (!isHybridApp()) { // The spinner ruins the hybrid app
            this.trigger(document, 'ui:side-menu:on-filter-click', {forceStart: true});
        }

        $(evt.target).addClass('search-filters-list-item-loading');
    };

    this._addSkipNavigationForHybrid = function (evt, origEl) {
        let $el = $(origEl.el),
            cleanedUrl;

        if ($el.attr('href')) {
            cleanedUrl = $el.attr('href') + '#skipNavigation';
            $el.attr('href', cleanedUrl);
        }
    };

    this._nullFunction = function () {
        // Empty function for FastClick workaround
        // We need to bind touchstart and touchend - they dont register correctly without this
        // 'click' is not always registered.
    };

    // This should be taken care of on the backend. But until implemented...
    this._cleanUrlsOnAllExceptCategories = function () {
        let $el, newUrl;

        if (this.$node.parents('.search-filters-animation-wrapper-categories').length < 1) {
            this.$node.find('a, option').each(function () {
                $el = $(this);
                if ($el.is('a') && !!($el.attr('href'))) {
                    newUrl = $el.attr('href').replace('&expanded=1', '');
                    $el.attr('href', newUrl);
                } else if ($el.is('option') && !!($el.attr('value'))) {
                    newUrl = $el.attr('value').replace('&expanded=1', '');
                    $el.attr('value', newUrl);
                }
            });
        }
    };

    this.after('initialize', function () {
        this._cleanUrlsOnAllExceptCategories();

        this.on('click', {
            boxHeader: this._toggleFilterBox,
            itemLinks: this._setLoadingStateOnSelected
        });

        if (isHybridApp()) {
            this.on('click', {
                itemLinks: this._addSkipNavigationForHybrid
            });
        }

        this.on('touchstart touchend', {
            itemLinks: this._nullFunction
        });
    });
}

export default  defineComponent.component(SearchResultFilterBoxUI);


// WEBPACK FOOTER //
// ./src/EbaySweden.TouchWeb/static/script/app/ui/search-result/search-result-filter-box-ui.js